import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../types/super-cut-field'
import { GridBlock } from '../../../../blocks'
import WatermarkFile from './fields/watermark-file'
import WatermarkPosition from './fields/watermark-position'
import WatermarkPreview from './fields/watermark-preview'

const FIELDS = [
    CreationToolSuperCutField.WatermarkFile,
    CreationToolSuperCutField.WatermarkPreview,
    CreationToolSuperCutField.WatermarkPosition,
]

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

const CreationCaptureInfoWatermark = () => {
    const fieldComponents = FIELDS.map((field) => {
        switch (field) {
            case CreationToolSuperCutField.WatermarkFile:
                return WatermarkFile
            case CreationToolSuperCutField.WatermarkPreview:
                return WatermarkPreview
            case CreationToolSuperCutField.WatermarkPosition:
                return WatermarkPosition
        }
    })

    return (
        <Fields columns={2}>
            {fieldComponents.map((Field, i) => (Field ? <Field key={FIELDS[i]} field={FIELDS[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoWatermark
